export default "__VITE_ASSET__C6r6oieu__"